export default "__VITE_ASSET__Nsb4aqOW__"